import { createFileRoute, Outlet } from '@tanstack/react-router';

import { SupplierLayout } from '@/features/supplier/supplier-layout';

export const Route = createFileRoute('/_app/supplier/$orgId')({ component: SupplierRoute });

function SupplierRoute() {
  const { orgId } = Route.useParams();
  return (
    <SupplierLayout orgId={orgId}>
      <Outlet />
    </SupplierLayout>
  );
}
